module.exports = __webpack_public_path__ + "static/pip_logo.217e0754.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pip_logo.png
// module id = 505
// module chunks = 35783957827783